export * from "./switch.component";